import axios from "../../../../../../../api/axiosInstance";
import {
  UpdateEventNotificationRequest,
  UpdateEventNotificationResponse,
} from "./types";

export const updateEventNotification = async (
  id: number,
  data: UpdateEventNotificationRequest,
): Promise<UpdateEventNotificationResponse> => {
  const response = await axios.put<UpdateEventNotificationResponse>(
    `/api/private/administration/events/notifications/${id}`,
    data,
  );

  return response.data;
};
